<template>
  <div>
    <Chart :cdata="cdata" :tabname="tabnames" :ecolor="ecolor"/>
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  data () {
    return {
      cdata: [],
      tabnames:[],
      ecolor:''
    }
  },
  components: {
    Chart,
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>